<template>

<section class="premium-section">

<h2 class="section-title">Technology Infrastructure</h2>

<p>
The Mudra platform is built using modern web technologies combined with blockchain infrastructure. This architecture enables fast performance, security, and scalability for creators using the platform.
</p>

<p>
By combining decentralized blockchain technology with modern web infrastructure, Mudra ensures transparency in token distribution and a smooth experience for users.
</p>


<h3 class="section-subtitle">Frontend Technology</h3>

<p>
The Mudra platform interface is developed using Vue.js. Vue allows fast and dynamic web applications and ensures the platform works smoothly on both desktop and mobile devices.
</p>


<h3 class="section-subtitle">Backend Infrastructure</h3>

<p>
Mudra uses Supabase as the backend infrastructure. Supabase manages authentication, database operations, and secure APIs that power the platform.
</p>


<h3 class="section-subtitle">Hosting Infrastructure</h3>

<p>
The Mudra website is hosted using Firebase Hosting which provides secure, scalable and fast global content delivery.
</p>


<h3 class="section-subtitle">Blockchain Integration</h3>

<p>
Mudra Token operates on the Polygon blockchain which provides low transaction fees and high transaction speed compared to traditional blockchain networks.
</p>


<h3 class="section-subtitle">Wallet Integration</h3>

<p>
Users interact with the Mudra ecosystem using wallets such as MetaMask which allows secure token storage and smart contract interaction.
</p>


<table class="premium-table">

<thead>
<tr>
<th>Technology Layer</th>
<th>Technology Used</th>
</tr>
</thead>

<tbody>

<tr>
<td>Frontend</td>
<td>Vue.js</td>
</tr>

<tr>
<td>Backend</td>
<td>Supabase</td>
</tr>

<tr>
<td>Hosting</td>
<td>Firebase Hosting</td>
</tr>

<tr>
<td>Blockchain</td>
<td>Polygon Network</td>
</tr>

<tr>
<td>Wallet</td>
<td>MetaMask</td>
</tr>

</tbody>

</table>

</section>

</template>